export default function Values() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Reliability & Honesty',
      description: 'We maintain unwavering reliability and honesty with our clients and suppliers. Our reputation is built on trust, transparency, and delivering on our commitments every single time.',
      color: 'from-[#8B1538] to-red-700'
    },
    {
      icon: 'ri-star-line',
      title: 'Quality Products',
      description: 'Quality product purchasing is foremost as a rule. We ensure every batch of chrome concentrate meets the highest standards, providing consistent quality that our clients can depend on.',
      color: 'from-gray-600 to-gray-700'
    },
    {
      icon: 'ri-time-line',
      title: 'Timely Service',
      description: 'Service delivered on time is our commitment. We understand the importance of JIT delivery and work tirelessly to ensure our clients receive their chrome products exactly when they need them.',
      color: 'from-[#8B1538] to-red-700'
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Management',
      description: 'Our team consists of individuals with combined over 40 years of experience, ranging from legal, mining, property, financial sector, marketing and sales, as well as engineering expertise.',
      color: 'from-gray-600 to-gray-700'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Market Understanding',
      description: 'We have an able pool of management that understands the commodity market very well and constantly follows trends. This expertise allows us to anticipate market needs and deliver value.',
      color: 'from-[#8B1538] to-red-700'
    },
    {
      icon: 'ri-funds-line',
      title: 'Cost Control',
      description: 'Costs controlled, purchasing and sales budget managed. We maintain strict financial discipline to ensure competitive pricing while delivering exceptional value to our clients.',
      color: 'from-gray-600 to-gray-700'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 font-['Montserrat']">
            Keys To Success
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            The principles that drive our excellence in chrome commodity trading and processing
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${value.color} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900 font-['Montserrat']">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
